import { render, staticRenderFns } from "./drawer.vue?vue&type=template&id=e6277b1e&"
import script from "./drawer.vue?vue&type=script&lang=js&"
export * from "./drawer.vue?vue&type=script&lang=js&"
import style0 from "./drawer.vue?vue&type=style&index=0&id=e6277b1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScheduleFilterCities: require('/opt/yamal.ru/src/components/schedule/filter/cities.vue').default,BaseBottomBar: require('/opt/yamal.ru/src/components/base/bottom-bar.vue').default})
